export default __webpack_public_path__ + "static/media/bespoken.f9171ede.svg";